import { zodErrorMap } from "@nimble/react-forms/zod-error-map";
import { ActionReasonEnum } from "@nimble/recommendation-client/types";
import z from "zod";

export const rejectMatchOptions = {
  NO_LONGER_LOOKING: {
    value: ActionReasonEnum.NO_LONGER_LOOKING,
    label: "No longer looking for a teaching job",
  },
  SCHOOL_TOO_FAR: {
    value: ActionReasonEnum.SCHOOL_TOO_FAR,
    label: "School is too far",
  },
  NO_MATCHING_OPENING: {
    value: ActionReasonEnum.NO_MATCHING_OPENING,
    label: "School doesn't have an opening for the grades or subjects I teach",
  },
  COMPENSATION_BENEFITS_UNMET: {
    value: ActionReasonEnum.COMPENSATION_BENEFITS_UNMET,
    label: "Compensation and benefits didn't meet my criteria",
  },
  WRONG_ENVIRONMENT: {
    value: ActionReasonEnum.WRONG_ENVIRONMENT,
    label: "Not the right environment for me",
  },
  OTHER: {
    value: ActionReasonEnum.OTHER,
    label: "Other",
  },
} as const;

export type RejectMatchOptionValue =
  (typeof rejectMatchOptions)[keyof typeof rejectMatchOptions]["value"];

const optionValues = Object.values(rejectMatchOptions).map(
  (opt) => opt.value,
) as [RejectMatchOptionValue, ...RejectMatchOptionValue[]];

export const rejectMatchFormSchema = z.object({
  reason: z.enum(optionValues, {
    error: zodErrorMap,
  }),
  explanation: z.string().optional(),
});

export type RejectMatchFormValues = z.infer<typeof rejectMatchFormSchema>;
